module.exports = __webpack_public_path__ + "img/new-sudbury-centre.0b929d5c.png";